// Les petits plaisirs qu'on peut s'offrir pour remonter son bien-être.
import type { TextKey } from './fr';

/** Les catégories de plaisirs : un plaisir ne s'use qu'au contact des plaisirs de la même catégorie. */
export type PleasureCategory = 'repas' | 'loisirs' | 'voyages' | 'achats' | 'soins';

export const PLEASURE_LABEL: Record<PleasureCategory, TextKey> = {
  repas: 'pleasure.repas',
  loisirs: 'pleasure.loisirs',
  voyages: 'pleasure.voyages',
  achats: 'pleasure.achats',
  soins: 'pleasure.soins',
};

export interface TreatDef {
  id: string;
  title: TextKey;
  price: number;
  /** Bien-être gagné pour le premier plaisir du mois de sa catégorie. */
  wellbeing: number;
  category: PleasureCategory;
}

export const TREATS: TreatDef[] = [
  { id: 'cine', title: 'treat.cine', price: 15, wellbeing: 1, category: 'loisirs' },
  { id: 'resto', title: 'treat.resto', price: 40, wellbeing: 3, category: 'repas' },
  { id: 'concert', title: 'treat.concert', price: 70, wellbeing: 4, category: 'loisirs' },
  { id: 'weekend', title: 'treat.weekend', price: 250, wellbeing: 8, category: 'voyages' },
];

/** Chaque plaisir acheté dans les 30 derniers jours de jeu divise par deux le suivant de la même catégorie. */
export const TREAT_WINDOW_DAYS = 30;
export const TREAT_DECAY = 0.5;
